import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import React from 'react';

interface Props {
  className?: string;
}

const Loader: React.FC<Props> = ({ className }) => {
  const { t } = useTranslationWithPrefix('components.loader');
  return (
    <output className={`flex justify-center items-center fixed z-10 inset-0 bg-white ${className}`}>
      <div className="spinner-border text-primary spinner-border-lg align-self-center">
        <span className="visually-hidden">{t('loading')}</span>
      </div>
    </output>
  );
};

export default Loader;
